export default __webpack_public_path__ + "static/media/SurchargeExample.d1604234.png";